import React, {Fragment} from 'react'
import {
  Button,
  Form,
  FormGroup,
  ModalBody,
  ModalHeader,
  UncontrolledAlert,
  Modal
} from 'reactstrap'
import PropTypes from 'prop-types'
import {inject, observer, PropTypes as ObservablePropTypes, Provider} from 'mobx-react'
import { action, observable, makeObservable } from 'mobx';

import {MarkdownEditor, MarkdownRenderer, Confirm} from '../../../components'
import {TaskTimeline} from "./TaskTimeline";
import {WorkflowTaskFormVertical} from "./WorkflowTaskForm";
import WorkflowTaskEntity from './WorkflowTaskEntity';
import {TryEdit} from "./TryEdit";
import {UserOrLoading} from "../../../services/users/components/UserOrLoading";
import SendTaskEmailStore from './SendTaskEmailStore';

import {analyticsTaskData} from '../analyticsHelper';
import {recordEvent} from '../../app/plugins/metricPlugin';

const Screens = {
  DETAILS: "Screens.DETAILS",
  SHARE_EMAIL: "Screens.SHARE_EMAIL"
}

export const CreatedInfo = inject("taskStore")(observer(class CreatedInfo extends React.Component {
  render() {
    const {taskStore, ...props} = this.props
    const {author, createdDate} = taskStore.editing;
    return <div {...props}>
      Created by {
        typeof author === 'string' ? author : <UserOrLoading user={author} justName />
      } at {
        createdDate.format('h:mma on MMM DD, YYYY')
      }
    </div>
  }
}));

export const TaskEditorModal = observer(class TaskEditorModal extends React.Component {

  static propTypes = {
    store: ObservablePropTypes.observableObject.isRequired,
    onClose: PropTypes.func
  };


  confirmDialog;
  screen;

  constructor(props){
    super(props);

    makeObservable(this, {
      confirmDialog: observable,
      screen: observable,
      onHide: action,
      onConfirmToggle: action,
      onCancel: action,
      goToScreen: action
    });
  }

  componentWillMount() {
    this.screen = Screens.DETAILS;
    this.emailStore = new SendTaskEmailStore();
    recordEvent("Task Viewed", this.getAnalyticsData())
  }


  stopEditing = () => {
    this.props.store.setEditMode(false);
    this.props.store.revertFormDraft();
    if (!this.props.store.editing._id) {
      this.props.store.hide()
    }
  };

  startEditing = () => {
    this.props.store.setEditMode(true)
    recordEvent("Task Edit", this.getAnalyticsData());
  };

  onSave = () => {
    this.props.store.saveTask()
      .then(this.props.store.hide)
      .then(() => recordEvent("Task Saved", this.getAnalyticsData()))
      .then(task => this.props.onSave && this.props.onSave(task))
      .catch(() => this.confirmDialog = false);
      //^validation back down to th

  };

  getAnalyticsData = () => {
    const {original} = this.props.store;
    return analyticsTaskData(original);
  }

  onHide = () => {
    const { store } = this.props;
    if(store.hasChanges){
      this.confirmDialog = true;
    }else{
      this.props.store.hide();
    }
  };

  onConfirmToggle = () => {
    this.confirmDialog = false;
  };

  onCancel = () => {
    this.props.store.hide();
  };


  goToScreen(screen) {
    this.stopEditing();
    this.screen = screen;
  }

  sendEmail = () => {
    const {editing} = this.props.store;

    if (editing.status === "NotStarted") {
      this.props.store.setStatus("InProgress");
    }

    this.emailStore.sendEmail(editing._id)
      .then(this.props.store.reloadTask)
      .then(this.props.store.saveTask()) //TODO - should this be invoked?
      .then(() => recordEvent("Task Shared", this.getAnalyticsData()))
      .then(() => this.goToScreen(Screens.DETAILS));
  };

  render() {
    const store = this.props.store;

    const task = store.editing;
    const visible = store.visible;
    let confirmDialog = (
      <Confirm
        visible={this.confirmDialog}
        header="Unsaved Changes"
        cancelText="Discard"
        confirmText="Save Changes"
        message="You have edited this task, are you sure you want to close with out saving?"
        onContinue={this.onSave}
        onCancel={this.onCancel}
        toggle={this.onConfirmToggle}
        zIndex={2000}
      />
    );

    return <Provider
      userResolver={this.props.store.userResolver}
      taskStore={this.props.store}
      commentsStore={this.props.store.commentsStore}
    ><Modal
      isOpen={!!task && visible}
      onClosed={this.props.onClose}
      toggle={() => {
        if (!this.props.store.hasChanges) { this.onHide() }
      }}
      // backdrop={true}
      size="xl">

      <ModalHeader toggle={this.onHide}>{task && task._id ? 'Task Details' : 'Create New Task'}</ModalHeader>
      <ModalBody>
        {
          !!task ? this.renderContent() : undefined
        }
        {confirmDialog}
      </ModalBody>
    </Modal>
    </Provider>

  }


  renderContent(){
    let content;
    switch(this.screen){
      case Screens.SHARE_EMAIL:
        content = this.renderShareByEmail();
        break;
      case Screens.DETAILS:
      default:
        content = this.renderTaskDetailScreen();
        break;
    }
    return (
      <Fragment>
      <Form className="row align-items-stretch">
        <div className="col-3 border-right">
          <WorkflowTaskFormVertical/>
        </div>
        <div className="col-9 d-flex flex-column">
          {content}
        </div>
      </Form>
      </Fragment>
    );
  }

  onShareByEmail = () => {
    recordEvent("Task Share Clicked", this.getAnalyticsData());
    this.goToScreen(Screens.SHARE_EMAIL)
  }



  renderTaskDetailScreen() {
    const store = this.props.store;
    const task = store.editing;
    const taskData = store.taskData;
    const isNew = store.isNewTask;
    //funky style to get the border to the top

    return (
      <Fragment>
        <FormGroup className="flex-row">
          {!!taskData && <div className="card-spacer-bottom"><WorkflowTaskEntity/></div>}
          <TaskTimeline />
        </FormGroup>
        <div className="row p-4">
          <div className="ml-auto">
            {!isNew && <button type="button" className="btn btn-secondary" onClick={this.onShareByEmail}>Share by Email</button>}
          </div>
          <div>
            {
              this.props.store.isEditMode ?
                <Fragment>
                  <Button color="secondary" outline={true} onClick={this.stopEditing}>Cancel</Button>
                  <Button className="control-spacer-left" color="secondary" onClick={this.onSave} disabled={store.invalidDescriptions.length ? true : false}>Save</Button>
                </Fragment>
                :
                undefined
            }
          </div>
        </div>
      </Fragment>
    );
  }

  renderShareByEmail(){
    const {taskData} = this.props.store;
    return (
      <Fragment>
        <div className="flex-row">
          {!!taskData && <WorkflowTaskEntity store={this.props.store}/>}
          <div className="form-group">
            {this.emailStore.errors.map(error => {
              return <UncontrolledAlert key={error} color="danger">
                  {error}
              </UncontrolledAlert>
            })}
            <label className="card-spacer-top">Email Address <span className="text-muted text-small">(comma separated)</span></label>
            <input placeholder="Enter Email" type="text" className="form-control" value={this.emailStore.email.to} onChange={(e) => this.emailStore.setEmail(e.target.value)}/>
          </div>
          <div className="form-group">
            <label>Subject</label>
            <input placeholder="Enter Subject" type="text" className="form-control" value={this.emailStore.email.subject} onChange={(e) => this.emailStore.setSubject(e.target.value)}/>
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea rows={5} placeholder="Enter Message" className="form-control" value={this.emailStore.email.message} onChange={(e) => this.emailStore.setMessage(e.target.value)}>
            </textarea>
          </div>
        </div>
        <div className="row p-4 text-right" style={{borderTop: '1px solid #EEE', marginTop: "auto"}}>
          <Button color="secondary" outline={true} disabled={this.emailStore.isSending} onClick={() => this.goToScreen(Screens.DETAILS)} className="ml-auto">Cancel</Button>
          <Button className="control-spacer-left" color="secondary" disabled={this.emailStore.isSending} onClick={this.sendEmail} >{this.emailStore.isSending ? 'Sending' : 'Send Email'}</Button>
        </div>
      </Fragment>
    );
  }
});

const TaskDescriptionEditor = inject("taskStore")(observer(class TaskDescriptionEditor extends React.Component {

  static propTypes = {
    taskStore: PropTypes.any,
  }

  onEdit = (value) => {
    this.props.taskStore.setDescriptionMarkdown(value)
  }

  render() {
    const isEditing = this.props.taskStore.isEditMode;
    const description = this.props.taskStore.editing.description;
    const containerSize = {maxHeight: '300px', minHeight: '200px', overflow: 'auto'};
    const isInvalid = this.props.taskStore.shouldShowInvalid('description');
    return isEditing ? <MarkdownEditor
      type="textarea" name="text" id="editTaskText"
      style={containerSize}
      className={isInvalid ? 'is-invalid' : ''}
      value={description}
      onChange={this.onEdit}
    /> : <TryEdit><MarkdownRenderer
      placeholder={'No Description'}
      style={{...containerSize, padding: '20px', border: '1px solid #EEE'}}
      value={description}
    /></TryEdit>;
  }
}));

